const apiConfigs = {
  ENV: `${process.env.REACT_APP_ENV}`,
  API_URL: `${process.env.REACT_APP_API_URL}`,
  APP_DOMAIN: `${process.env.REACT_APP_DOMAIN}`,
  APP_REDIRECT_SIGN_IN: `${process.env.REACT_APP_REDIRECT_SIGN_IN}`,
  APP_REDIRECT_SIGN_OUT: `${process.env.REACT_APP_REDIRECT_SIGN_OUT}`,
  APP_RESPONSE_TYPE: `${process.env.REACT_APP_RESPONSE_TYPE}`,
  APP_S3_BUCKET: `${process.env.REACT_APP_S3_BUCKET}`,
  CONFIG: {
    REGION: `${process.env.REACT_APP_REGION}`,
    USER_POOL: `${process.env.REACT_APP_USER_POOL}`,
    CLIENT_ID: `${process.env.REACT_APP_CLIENT_ID}`,
    GATEWAY_URL: `${process.env.REACT_APP_GATEWAY_URL}`,
    IDENTITY_POOL_ID: `${process.env.REACT_APP_IDENTITY_POOL_ID}`,
    ACCESSKEYID: `${process.env.REACT_APP_ACCESSKEYID}`,
    SECRETACCESSKEY: `${process.env.REACT_APP_SECRETACCESSKEY}`
  },
  RECAPTCHA_SITE_KEY: `${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`,
  DEV_ASYNK_URL: `${process.env.REACT_APP_DEV_ASYNK_URL}`,
  DEV_ASYNC_INVITE_URL: `${process.env.REACT_APP_DEV_ASYNC_INVITE_URL}`,
  DEV_MOD_URL: `${process.env.REACT_APP_DEV_MOD_URL}`,
  STIMULUS_URL: `${process.env.REACT_APP_STIMULUS_URL}`,
  STIMULUS_REGISTERATION_TOKEN: `${process.env.REACT_APP_STIMULUS_REGISTERATION_TOKEN}`,
  MQTT_SERVICE_NAME: `${process.env.REACT_APP_MQTT_SERVICE_NAME}`,
  MQTT_SERVICE_URL: `${process.env.REACT_APP_MQTT_SERVICE_URL}`,
  Branchio_key: `${process.env.REACT_APP_BRANCHIO_KEY}`,
  SHARING_URL: `${process.env.REACT_APP_SHARING_URL}`,
  stripePublishableKeyTest: `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST}`,

  S3_IMG_URL: `${process.env.REACT_APP_S3_IMG_URL}`,
  INTERCOM_URL: `${process.env.REACT_APP_INTERCOM_URL}`,
  INTERCOM_DATA_CLEAN_URL: `${process.env.REACT_APP_INTERCOM_DATA_CLEAN_URL}`,

  COMPANY_URL: `${process.env.REACT_APP_COMPANY_URL}`,
  CONTACT_US_URL: `${process.env.REACT_APP_CONTACT_US_URL}`,
  stripePublishableKeyLive: `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_LIVE}`,
  BRAINTRUST_SIMULATE_SESSION: `${process.env.REACT_APP_BRAINTRUST_SIMULATE_SESSION}`,
  CALENDLY_URL: `${process.env.REACT_APP_CALENDLY_URL}`,
  logAws: {
    logGroupName: process.env.REACT_APP_LOG_GROUP_NAME,
    logStreamName: process.env.REACT_APP_LOG_STREAM_NAME,
    logAccessKeyId: process.env.REACT_APP_LOG_ACCESS_KEY_Id,
    logSecretAccessKey: process.env.REACT_APP_LOG_SECRET_ACCESS_KEY
  },
  DOCUMENT_API_URL: `${process.env.REACT_APP_DOCUMENT_API_API}`,
  CLOUD_FRONT_URL: `${process.env.REACT_APP_CLOUD_FRONT_URL}`,
  MOD_THRESHOLD_LENGTH: `${process.env.REACT_APP_MOD_THRESHOLD_LENGTH}`,
  ASYNC_THRESHOLD_LENGTH: `${process.env.REACT_APP_ASYNC_THRESHOLD_LENGTH}`,
  COOSPO_LINK: `${process.env.REACT_APP_COOSPO_LINK}`,
  APPLE_WATCH_LINK: `${process.env.REACT_APP_APPLE_WATCH_LINK}`,
  SUCCESS_EMAIL: `${process.env.REACT_APP_SUCCESS_EMAIL}`,
  SUPPORT_EMAIL: `${process.env.REACT_APP_SUPPORT_EMAIL}`,
  NAVBAR_LOGO: `${process.env.REACT_APP_NAVBAR_LOGO}`,
  NAVBAR_BACKGROUND: `${process.env.REACT_APP_NAVBAR_BKGROUND}`,
  NAVBAR_PRIMARY: `${process.env.REACT_APP_NAVBAR_PRIMARY}`,
  NAVBAR_ACTIVE: `${process.env.REACT_APP_NAVBAR_ACTIVE}`,
  KNOWN_PRIVACY_URL: `${process.env.REACT_APP_KNOWN_PRIVACY_POLICY_URL}`,
  KNOWN_LEGAL_URL: `${process.env.REACT_APP_KNOWN_LEGAL_URL}`,
  KNOWN_PRICING_URL: `${process.env.REACT_APP_KNOWN_PRICING_URL}`,
  DEFAULT_PRICING_SCHEME: `${process.env.REACT_APP_DEFAULT_AUTH}`,
  DEFAULT_AUTH_SCHEME: `${process.env.REACT_APP_DEFAULT_AUTH}`,
  DEFAULT_SUBBRAND: `${process.env.REACT_APP_DEFAULT_SUBBRAND}`,
  billing: {
    strategy: `${process.env.REACT_APP_BILLING_STRATEGY}`,
    email: `${process.env.REACT_APP_BILLING_EMAIL}`,
    planLow: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_LOW}`,
    planLowPriceId: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_LOW_PRICEID}`,
    planLowUsagePriceId: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_LOW_USAGE_PRICEID}`,
    
    planMedium: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_MEDIUM}`,
    planMediumPriceId: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_MEDIUM_PRICEID}`,
    planMediumUsagePriceId: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_MEDIUM_USAGE_PRICEID}`,

    planHigh: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_HIGH}`,
    planHighPriceId: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_HIGH_PRICEID}`,
    planHighUsagePriceId: `${process.env.REACT_APP_BILLING_PLAN_LEVEL_HIGH_USAGE_PRICEID}`,

    planUsagePriceId: `${process.env.REACT_APP_BILLING_PLAN_USAGE_PRICEID}`,
    success_url: `${process.env.REACT_APP_BILLING_SUCCESS_URL}`,
    failure_url: `${process.env.REACT_APP_BILLING_FAILURE_URL}`
  },
  MIXPANEL_TOKEN: `${process.env.REACT_APP_MIXPANEL_TOKEN}`
};
export default apiConfigs;